import { css } from '@emotion/css';

export const questionEditorStyles = css`
  .ProseMirror {
    padding: 1.6rem;
  }

  &.heading-m {
    font-size: 2rem;
    font-weight: normal;
  }

  pre {
    background: var(--bg-secondary) !important;
    border-radius: 0.8rem;
    padding: 1.6rem 2rem;

    code {
      white-space: pre-wrap;
    }
  }
`;
